import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import { throttle } from 'lodash';
import { getDistanceFromTop } from '../../utils/position.js'

import './Navigation.css'

class Nav extends Component {

    constructor(props) {

        super(props)

        this.state = {
            show: false,
            threshold: 200
        }

        this.scroll = this.scroll.bind(this);
        this.bind = this.bind.bind(this);
        this.removeBind = this.removeBind.bind(this);

    }

    scroll(e) {


        let top = getDistanceFromTop()

        let show = (top > this.state.threshold) ? false : true

        this.setState({
            show
        });

    }



    componentDidMount() {

        this.cb = throttle(this.scroll)

        this.bind();
    }

    componentWillUnmount() {
        this.removeBind();
    }


    bind() {
        window.addEventListener('scroll', this.cb);
    }

    removeBind() {
        window.removeEventListener('scroll', this.cb);
    }


    render() {

        const { routes, toggle, isOpen } = this.props

        const navStyle = {
            transform: isOpen ? 'translateX(0)' : 'translateX(100%)',
            visibility: isOpen ? 'visible' : 'hidden',
        }


        return (
            <nav style={navStyle} role="navigation" aria-label="Main navigation" id="main-navigation">
                <ul className="test" role="menubar">
                    {routes.map((route, index) => {
                        return route.isPrimary ? <li key={index} role="none">
                            <NavLink 
                                onClick={toggle} 
                                end={route.exact} 
                                to={route.path} 
                                role="menuitem"
                                className={({ isActive }) => isActive ? "active" : ""}
                                aria-current={({ isActive }) => isActive ? "page" : undefined}
                            >
                                {route.title}
                            </NavLink>
                        </li> : false
                    })}

                </ul>
            </nav>
        );
    }
}

export default Nav;
